'use strict';

let TOAST_CONTAINER = null;
let bottomStickyTimer = null;

const getContainer = function() {
  return (TOAST_CONTAINER =
    TOAST_CONTAINER ||
    document.getElementById('goods-urgency-toast-container'));
};

const setBloodHoundAttributes = function(div, message) {
  div.setAttribute('data-bhc', `toast:goods-urgency-${message.type}`);
  div.setAttribute('data-bhd', JSON.stringify(message.data));
  div.setAttribute('data-bh-viewport', 'respect');
};

const createDiv = function(className, message, delay) {
  const div = document.createElement('div');
  div.className = `notification ${className}`;
  div.style.animation = `fadein 0.5s, fadeout 0.5s ${delay / 1000 - 0.5}s`;
  setBloodHoundAttributes(div, message);
  return div;
};

const removeDiv = function(div, time_out, delay = 5000) {
  setTimeout(() => {
    const toast = getContainer();
    toast.removeChild(div);
    if (time_out !== null) {
      clearInterval(time_out);
    }
  }, delay);
};

const bottomStickyTimerHandler = function() {
  const stickyBuyText = document.querySelector(
    '#sticky-footer .sticky-buy-text'
  );
  const countDownTimer = document.querySelector(
    '#sticky-footer .sticky-buy-text .countdown-timer'
  );
  return {
    update: function(div, message) {
      div.innerHTML = window.I18n.translate(
        `js.modules.goods_urgency_prominence.timer.${message.data.length}`,
        {
          urgencyText: `<strong>${countDownTimer.textContent}</strong>`,
        }
      );
    },
    hideElement: function() {
      stickyBuyText.style.visibility = 'hidden';
    },
  };
};

const setNotificationText = function(div, message) {
  if (message && message.type === 'timer') {
    bottomStickyTimer.update(div, message);
    return setInterval(() => {
      bottomStickyTimer.update(div, message);
    }, 1000);
  } else {
    div.innerHTML = message.text;
  }
  return null;
};

const createNotification = function(className, message, delay) {
  bottomStickyTimer = bottomStickyTimerHandler();
  bottomStickyTimer.hideElement();
  const div = createDiv(className, message, delay);
  const time_out = setNotificationText(div, message);
  getContainer().appendChild(div);
  removeDiv(div, time_out, delay);
};

const success = function({ message, delay }) {
  createNotification('success', message, delay);
};

const error = function({ message, delay }) {
  createNotification('error', message, delay);
};

const warning = function({ message, delay }) {
  createNotification('warning', message, delay);
};

const info = function({ message, delay }) {
  createNotification('info', message, delay);
};

module.exports = {
  success,
  error,
  warning,
  info,
};
